import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import {
  getFormValues,
  initialize,
  getFormSyncErrors,
  touch,
} from 'redux-form';
import { isNullOrUndefined } from 'util';

import { Filter, Main } from 'Containers';
import { FileConfigForm } from '../components/fileconfig/FileConfigForm';
import { DC_IMPORT_SETTINGS_FORM } from 'Common/FormEnum';
import { DCImportFieldEnum as Fields } from 'Common/FieldEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { createToast, toastType } from 'Common/ToastHelper';
import { ImportSettingsForm } from '../components/importsettings/ImportSettingsForm';
import { getCaseTypes } from 'State/caseTypes/actions';
import { HeaderOptions } from '../helpers/Constants';
import { getRequiredHeaders, getDisabledHeaders } from '../helpers/Helpers';
import {
  deleteConfig,
  saveConfig,
  saveConfigName,
  setRedirectHome,
} from '../state/fileconfig/actions';
import { InputDialog, YesNoDialog } from 'Components';
import { resetDirty } from 'State/dirtyTracking/actions';

class FileConfiguration extends Component {
  static path = '/dcimport/fileconfig';

  state = { showSaveDialog: false, showDeleteDialog: false };

  componentDidMount() {
    if (this.props.selectedConfigId === -2) {
      this.props.history.push(this.getRootUrl());
      return;
    }
    this.props.getCaseTypes();
    this.props.initialize(DC_IMPORT_SETTINGS_FORM, this.props.fileConfig);
    this.props.resetDirty();
  }

  componentDidUpdate(prevProps) {
    if (this.props.redirectHome && !prevProps.redirectHome) {
      this.props.setRedirectHome(false);
      this.props.history.push(this.getRootUrl());
    }
  }

  getRootUrl = () => {
    return this.props.match.url.replace(/\/fileconfig.?/gi, '');
  };

  onToolboxBackClick = () => {};

  saveNewConfig = name => {
    const { selectedConfigId, formValues } = this.props;
    const config = this.getConfig(
      selectedConfigId,
      name,
      formValues,
      this.getSelectedFieldsString(),
      this.getCustomSettings()
    );
    this.props.saveConfig(config);
    this.props.resetDirty();
  };

  onSaveClick = () => {
    this.props.touch(
      DC_IMPORT_SETTINGS_FORM,
      Fields.ImportType,
      Fields.DefaultCaseType
    );
    this.saveConfig();
  };

  onDeleteClick = () => {
    this.setState({ showDeleteDialog: true });
  };

  onDeleteConfirm = () => {
    this.setState({ showDeleteDialog: false });
    this.props.deleteConfig(this.props.selectedConfigId);
  };

  onDeleteCancel = () => {
    this.setState({ showDeleteDialog: false });
  };

  saveConfig = () => {
    const { formValues, selectedConfigName, selectedConfigId } = this.props;

    const headerMapping =
      formValues && !isNullOrUndefined(formValues[Fields.HeaderMapping])
        ? formValues[Fields.HeaderMapping]
        : [];
    let missingHeaders = '';
    getRequiredHeaders(formValues).forEach(header => {
      if (
        headerMapping.findIndex(mappedHeader => mappedHeader === header) === -1
      ) {
        const headerText = HeaderOptions.find(
          element => element.value === header
        ).text;
        missingHeaders =
          missingHeaders.length === 0
            ? header
            : `${headerText}, ${missingHeaders}`;
      }
    });

    if (missingHeaders.length > 0) {
      createToast(
        toastType.error,
        'Missing Required Headers',
        `Required header(s) ${missingHeaders} must be mapped.`
      );
      return;
    }
    if (
      !this.props.syncErrors ||
      Object.keys(this.props.syncErrors).length === 0
    ) {
      if (this.isNewConfig()) {
        this.setState({ showSaveDialog: true });
        return;
      }
      const config = this.getConfig(
        selectedConfigId,
        selectedConfigName,
        formValues,
        this.getSelectedFieldsString(),
        this.getCustomSettings()
      );
      this.props.saveConfig(config);
      this.props.resetDirty();
    }
  };

  getSelectedFieldsString() {
    const { formValues } = this.props;

    const headerMapping =
      formValues && !isNullOrUndefined(formValues[Fields.HeaderMapping])
        ? formValues[Fields.HeaderMapping]
        : [];

    let selectedFields = '';
    for (var i = 0; i < headerMapping.length; i++) {
      !isNullOrUndefined(headerMapping[i]) && headerMapping[i] !== -1
        ? (selectedFields += `${headerMapping[i]}|`)
        : (selectedFields += `Skip|`);
    }
    if (selectedFields.length > 0) {
      selectedFields = selectedFields.slice(0, -1);
    }

    return selectedFields;
  }

  getCustomSettings() {
    const { formValues } = this.props;
    return {
      [Fields.MatchOn]: formValues[Fields.MatchOn],
      [Fields.ApplicationDate]: formValues[Fields.ApplicationDate],
      [Fields.UseCaseTypeMapping]: formValues[Fields.UseCaseTypeMapping],
      [Fields.DefaultCaseType]: formValues[Fields.DefaultCaseType],
      [Fields.UseAddressInFile]: formValues[Fields.UseAddressInFile],
      [Fields.CreateFamilies]: formValues[Fields.CreateFamilies],
      [Fields.IgnoreStateNumberLeadingZeros]:
        formValues[Fields.IgnoreStateNumberLeadingZeros],
    };
  }

  getConfig(id, name, formValues, selectedFields, customSettings) {
    return {
      Id: id < 1 ? 0 : id,
      Name: name,
      ImportTypeId: formValues[Fields.ImportType],
      IncludeHeaders: formValues[Fields.ContainsHeaderInformation] ? 1 : 0,
      Delimiter: formValues[Fields.Delimiter],
      FilePath: formValues[Fields.FileName],
      SelectedFields: selectedFields,
      CustomSettings: JSON.stringify(customSettings),
    };
  }

  getMainProps = () => {
    const { isReadOnly } = this.props;

    return {
      toolbox: {
        isReadOnly,
        backButtonProps: {
          shown: true,
          path: this.getRootUrl(),
          callback: this.onToolboxBackClick,
        },
        formName: DC_IMPORT_SETTINGS_FORM,
        saveButtonProps: {
          content: 'Save',
          onClick: this.onSaveClick,
        },
        shown: true,
      },
    };
  };

  isNewConfig = () => this.props.selectedConfigId === -1;

  render() {
    return (
      <Fragment>
        <Filter
          title={
            !this.isNewConfig()
              ? `Edit Configuration - ${this.props.selectedConfigName}`
              : 'Create New Configuration'
          }
        >
          {!this.isNewConfig() ? (
            <div>
              <Button className={'pull-right'} onClick={this.onDeleteClick}>
                Delete Configuration
              </Button>
            </div>
          ) : (
            undefined
          )}
        </Filter>
        <Main {...this.getMainProps()}>
          <ImportSettingsForm
            initialValues={this.props.fileConfig}
            caseTypes={this.props.caseTypes}
            loading={this.props.loading}
            onSubmit={() => {}}
          />
          <FileConfigForm
            fileData={this.props.fileData}
            initialValues={this.props.fileConfig}
            loading={this.props.loading}
            getRequiredHeaders={getRequiredHeaders}
            getDisabledHeaders={getDisabledHeaders}
            onSubmit={() => {}}
          />
          <InputDialog
            showDialog={this.state.showSaveDialog}
            title={'Save Configuration As'}
            message={'What would you like to name this configuration?'}
            onOkClick={name => {
              this.saveNewConfig(name);
              this.setState({ showSaveDialog: false });
            }}
            onCancelClick={() => {
              this.setState({ showSaveDialog: false });
            }}
            maxLength={20}
          />
          <YesNoDialog
            title={'Delete this configuration?'}
            question={`Are you sure you want to delete configuration ${this.props.selectedConfigName}?`}
            showDialog={this.state.showDeleteDialog}
            yesCallback={this.onDeleteConfirm}
            noCallback={this.onDeleteCancel}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { caseTypes, fetching } = state.CommonState;
  ownProps.setPageLevelDirty(getIsDirty(DC_IMPORT_SETTINGS_FORM)(state));
  return {
    loading: state.DCImportState.common.fetching || fetching,
    fileData: state.DCImportState.common.fileData,
    fileConfig: state.DCImportState.common.fileConfig,
    formValues: getFormValues(DC_IMPORT_SETTINGS_FORM)(state),
    syncErrors: getFormSyncErrors(DC_IMPORT_SETTINGS_FORM)(state),
    caseTypes: caseTypes.data,
    selectedConfigName: state.DCImportState.common.selectedConfigName,
    selectedConfigId: state.DCImportState.common.selectedConfigId,
    redirectHome: state.DCImportState.fileConfig.redirectHome,
  };
};

FileConfiguration = withRouter(
  connect(
    mapStateToProps,
    {
      getCaseTypes,
      saveConfig,
      saveConfigName,
      resetDirty,
      initialize,
      deleteConfig,
      setRedirectHome,
      touch,
    }
  )(FileConfiguration)
);

export { FileConfiguration };



// WEBPACK FOOTER //
// ./src/pages/dcimport/subpages/FileConfiguration.js